import Stack from '@mui/material/Stack';

import config from '../../config/config';
import {getSessionStatus} from '../../helpers/sessions';
import * as StringUtils from "../../helpers/stringUtils";
import './SessionStatus.scss';
import {CircleIcon} from "../../styles/icons";
import Typography from "@mui/material/Typography";

export const getStatusOptions = status => {
  let options = {};
  switch (status) {
    case 'Completed':
      options = {
        Icon: CircleIcon,
        color: config().colors.deepTeal,
      };
      break;
    case 'Upcoming':
      options = {
        Icon: CircleIcon,
        color: config().colors.primary,
      };
      break;
    case 'Canceled':
      options = {
        Icon: CircleIcon,
        color: config().colors.goldSand,
      };
      break;
    case 'Incomplete':
      options = {
        Icon: CircleIcon,
        color: config().colors.secondary,
      };
      break;
    case 'All':
      options = {
        Icon: CircleIcon,
        color: config().colors.light2,
      };
      break;
    default:
      options = {
        Icon: null,
        color: config().colors.light2,
      };
      break;
  }
  return options;
};

const SessionStatus = props => {
  const { onlyIcon } = props;
  let showText = !!props.status;
  const isClickable = !!props.onTabChange;
  const onTabChange = (status) => { if(isClickable) {props.onTabChange(status)} };
  const status = props.status ? StringUtils.capitalize(props.status) :  getSessionStatus(props.session);
  const {color, Icon} = getStatusOptions(status);

  if (onlyIcon) {
    return (
      <Icon style={{fill: color, width: '15px', height: '15px'}} />
    )
  }

  return (
    <Stack
      direction='row'
      spacing={{xs: 1.5}}
      alignItems='center'
      onClick={() => onTabChange(props.status)}
    >
      <Icon style={{fill: color, width: '15px', height: '15px'}} />
      {
        showText &&
          <Typography
            variant='normal'
            className={`${props.active ? 'session-status__active' : ''}`}
            noWrap
          >
            {status} ({props.statusCount})
          </Typography>
      }
    </Stack>
  );
};

export default SessionStatus;
